// extracted by mini-css-extract-plugin
module.exports = {"container":"_2lF_MdzOxJqnJjWJt0RKc_","content":"_2TK4GzdbSZFHBhPqvwoRJU","footer":"_2sKjN9JaTMeuE6SAHNvIZM","headerFixed":"_3KPknggncaXn720iSCavL-"};